<template>
  <section id="aboutUs" class="relative">
    <img
      src="@images/landing-page/dots.svg"
      alt=""
      aria-hidden="true"
      class="pointer-events-none absolute -translate-x-[10rem] -translate-y-14 rotate-[150deg] opacity-20 md:-translate-x-[20rem] lg:-translate-x-[10rem]"
      loading="lazy"
    />

    <img
      src="@images/landing-page/rounded-bars.svg"
      alt=""
      aria-hidden="true"
      class="pointer-events-none absolute end-0 bottom-56 translate-x-[15rem] scale-150 -rotate-[30deg] opacity-20 sm:scale-110 md:bottom-0 md:translate-x-[40rem] md:-translate-y-[15rem] md:scale-125 lg:scale-100"
      loading="lazy"
    />

    <div class="relative mx-auto max-w-[85rem] space-y-20 px-4">
      <div class="z-auto space-y-3">
        <h2 class="text-center font-exo-bold text-5xl text-pretty uppercase lg:text-6xl">
          why teams <span class="bg-linear-to-r from-mauve-500 to-navy-blue-500 bg-clip-text text-transparent">vibe</span> with us
        </h2>
        <p class="text-center text-eerie-black-200">From side projects to big launches, your AI crew grows with your goals.</p>
      </div>
      <div class="grid gap-5 md:grid-cols-3 md:gap-6 lg:gap-10">
        <div v-for="(card, index) in vibeWithUsCards" :key="index" class="card grid gap-3 transition-transform hover:-translate-y-1">
          <img :src="card.icon" :alt="`${card.title} Icon`" class="h-10 w-10 md:h-14 md:w-14" loading="lazy" />
          <h3 class="font-exo-bold text-xl md:text-2xl">{{ card.title }}</h3>
          <p class="text-sm text-eerie-black-200 md:text-base">{{ card.description }}</p>
        </div>
      </div>
    </div>
  </section>
</template>

<script lang="ts">
import AiAgentsIcon from '@images/landing-page/ai-agents.svg';
import NoCodePlatformIcon from '@images/landing-page/no-code-platform.svg';
import TeamCollabIcon from '@images/landing-page/team-collab.svg';

export default {
  name: 'VibeWithUs',
  data() {
    return {
      vibeWithUsCards: [
        {
          icon: AiAgentsIcon,
          title: 'Custom AI Agents',
          description: 'Design unique AI personalities with specific expertise, capabilities, and communication styles tailored to your needs.',
        },
        {
          icon: TeamCollabIcon,
          title: 'Team Collaboration',
          description:
            "Watch your AI agents work together in real-time, sharing context and building on each other's insights to solve complex problems.",
        },
        {
          icon: NoCodePlatformIcon,
          title: 'No-Code Platform',
          description:
            'Build powerful AI teams through our intuitive interface. No programming knowledge required - just pure creativity and vision.',
        },
      ],
    };
  },
};
</script>
